import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store'
import i18n from "@/localization/i18n";
import vuetify from "./plugins/vuetify";
import Leaflet from "./services/leaflet.service";
// import VueKeyCloak from "@dsb-norge/vue-keycloak-js";
import axios from "axios";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import tokenInterceptor from "./services/interceptors";
//export const BackendBaseUrl = import.meta.env.VITE_BACKEND_BASE_URL;

Vue.config.productionTip = false;
Vue.prototype.$leaflet = new Leaflet();
Vue.prototype.$leafletDetail = new Leaflet();
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_BASE_URL;
// axios.defaults.baseURL = "https://swift-aoi.dev.eomap.com/";

import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: process.env.VUE_APP_AUTH_URL,
  realm: "eomap",
  clientId:'swift-aoi'
});

keycloak
  .init({
    onLoad: "check-sso",
    redirectUri: window.location.origin
  })
  .then(authenticated => {
    Vue.prototype.$keycloak = keycloak;

    if (authenticated) {
      // // Set up token refresh
      tokenInterceptor();
      // Start Vue app
      new Vue({
      router,
      store,
      vuetify,
      i18n,
      render: h => h(App)
    }).$mount("#app");
    } else {
      keycloak.login();
    }

  })
  .catch(error => {
    console.error("Keycloak init error:", error);
  });

